module.exports = __webpack_public_path__ + "static/media/openModal.18348877.mp3";